module.exports = __webpack_public_path__ + "img/Frame 157.0c66acb5.svg";